import * as React from "react";

const SvgSquare = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 38"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_7378_13589"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" fillOpacity="0.92" />
    </mask>
    <g mask="url(#mask0_7378_13589)">
      <path
        d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M9.37172 27.7273V35H7.83407V29.1868H7.79146L6.12598 30.2308V28.8672L7.9264 27.7273H9.37172ZM11.9987 34.1548C11.7643 34.1548 11.5631 34.072 11.395 33.9062C11.2293 33.7405 11.1464 33.5393 11.1464 33.3026C11.1464 33.0705 11.2293 32.8717 11.395 32.706C11.5631 32.5402 11.7643 32.4574 11.9987 32.4574C12.2259 32.4574 12.4248 32.5402 12.5953 32.706C12.7657 32.8717 12.8509 33.0705 12.8509 33.3026C12.8509 33.4588 12.8107 33.602 12.7302 33.7322C12.6521 33.8601 12.5491 33.9631 12.4213 34.0412C12.2934 34.117 12.1526 34.1548 11.9987 34.1548ZM11.9987 30.5859C11.7643 30.5859 11.5631 30.5031 11.395 30.3374C11.2293 30.1716 11.1464 29.9704 11.1464 29.7337C11.1464 29.5017 11.2293 29.304 11.395 29.1406C11.5631 28.9749 11.7643 28.892 11.9987 28.892C12.2259 28.892 12.4248 28.9749 12.5953 29.1406C12.7657 29.304 12.8509 29.5017 12.8509 29.7337C12.8509 29.8923 12.8107 30.0367 12.7302 30.1669C12.6521 30.2947 12.5491 30.3965 12.4213 30.4723C12.2934 30.5481 12.1526 30.5859 11.9987 30.5859ZM17.2428 27.7273V35H15.7052V29.1868H15.6626L13.9971 30.2308V28.8672L15.7975 27.7273H17.2428Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgSquare;
